// ECOIMPACT TRACKER PAGE
export const ecoimpactContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                  color: 'white',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Mobile Apps
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'EcoImpact Tracker', size: 'h1' },
        {
          type: 'text',
          content: 'Track and reduce your environmental footprint',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'An environmental impact tracking app that helps users monitor their carbon footprint and make more sustainable choices.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <span style={{
              background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '600'
            }}>
              Completed
            </span>
          )
        }
      ]
    },

    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '🌱', title: 'Carbon Tracking', desc: 'Monitor your daily carbon footprint' },
                { icon: '📈', title: 'Progress Charts', desc: 'Visualize your environmental impact over time' },
                { icon: '🎯', title: 'Eco Goals', desc: 'Set and track sustainability targets' },
                { icon: '💡', title: 'Green Tips', desc: 'Personalized suggestions for reducing impact' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    {
      id: 'tech',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {['React Native', 'Expo', 'Data Visualization', 'Carbon APIs'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>{tech}</span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'EcoImpact Tracker',
    text: 'Make every choice count for the planet',
    button: { text: 'See more work →', url: '/' }
  }
};
